import { PERMISSION_IDS } from '../constants/permissions';

export function hasApplicantProfileNavigate(permissionIds: number[]): boolean {
  return permissionIds.includes(PERMISSION_IDS.APPLICANT_PROFILE_NAVIGATE);
}

/** Name cell uses click permission (1); UI may still show pointer from a separate rule — keep both explicit. */
export function isApplicantNameClickable(permissionIds: number[]): boolean {
  return permissionIds.includes(PERMISSION_IDS.APPLICANT_NAME_CLICK);
}

export function showVacancyCodeAddControl(
  permissionIds: number[],
  vacancyCode: string | null | undefined,
): boolean {
  return (
    permissionIds.includes(PERMISSION_IDS.APPLICANT_VACANCY_CODE_EDIT) && !vacancyCode
  );
}

export function showCountryAddControl(
  permissionIds: number[],
  countryKey: string | null | undefined,
): boolean {
  return permissionIds.includes(PERMISSION_IDS.APPLICANT_COUNTRY_EDIT) && !countryKey;
}

export interface ApplicantComparisonButtonState {
  disabled: boolean;
  loadingLabel: boolean;
}

export function getApplicantComparisonButtonState(
  rowId: number,
  row: {
    cvComparisonInProgress?: boolean;
    overallScore?: number;
  },
  isGeneratingComparison: number | null,
  comparisonInitiated: Set<number>,
): ApplicantComparisonButtonState {
  const disabled =
    isGeneratingComparison === rowId ||
    !!row.cvComparisonInProgress ||
    comparisonInitiated.has(rowId) ||
    (row.overallScore ?? 0) > 0;
  return {
    disabled,
    loadingLabel: isGeneratingComparison === rowId,
  };
}
